__turbopack_context__.v({
  "sourceCard": "CollateralModal-module-scss-module__5v_lyW__sourceCard",
  "sourceIcon": "CollateralModal-module-scss-module__5v_lyW__sourceIcon",
});
